<aw-dialog
  class="max-h-[80vh] w-full bg-white sm:w-[400px]"
  (onClose)="dialogRef.close()"
  [content]="editTicketOwnerDialogContent"
  [footer]="footerContent"
  [data]="data"
  [title]="
    (textStore.texts()
      | filterTexts
        : ERelationType.shoppingCartPassengerDataLabel
        : EEntityType.shoppingCart
      | language) ?? data.name
  "
  [width]="'400px'">
  <ng-template #editTicketOwnerDialogContent>
    <div class="flex w-full flex-col gap-4">
      @for (ticketOwnerForm of ticketOwnerForms.controls; track $index) {
        <aw-direct-ticket-owner-data-form
          [id]="data.productDefinition.name + '-' + $index"
          [ticketName]="data.productDefinition.name"
          [ticketOwnerForm]="
            ticketOwnerForm
          "></aw-direct-ticket-owner-data-form>
      }
    </div>
  </ng-template>
  <ng-template #footerContent>
    <div class="flex w-full flex-row items-center justify-between pt-4">
      <aw-button
        type="button"
        [style]="'primary-alt'"
        id="ticket-remove-from-cart-dialog-cancel"
        (click)="dialogRef.close()"
        (keydown.enter)="dialogRef.close()"
        >{{
          textStore.texts()
            | filterTexts: ERelationType.cancel : EEntityType.generic
            | language
        }}</aw-button
      >
      <aw-button
        type="button"
        id="ticket-remove-from-cart-dialog-submit"
        [disabledText]="
          textStore.texts()
            | filterTexts: ERelationType.saveDisabled : EEntityType.generic
            | language
        "
        [isDisabled]="!ticketOwnerForms.valid"
        (click)="saveChanges()"
        (keydown.enter)="saveChanges()"
        >{{
          textStore.texts()
            | filterTexts: ERelationType.save : EEntityType.generic
            | language
        }}</aw-button
      >
    </div>
  </ng-template>
</aw-dialog>
